/**
 * cart-check.js
 * Affiche une coche de validation animée sur l'icône panier (#cart-icon-bubble)
 * à chaque ajout au panier.
 *
 * Dépendances (chargées avant, dans le <head> en defer) :
 *   - pubsub.js    → subscribe()
 *   - constants.js → PUB_SUB_EVENTS
 *
 * Se branche sur l'événement global cart-update, publié par tous les
 * boutons d'ajout du thème (product-form, carte produit custom, quick-add).
 * On ignore la source 'cart-items' (simple changement de quantité dans le panier).
 */
(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  var CHECK_SVG =
    '<svg class="cart-icon-check__svg" viewBox="0 0 36 36" aria-hidden="true" focusable="false">' +
    '<circle class="cart-icon-check__circle" cx="18" cy="18" r="16"/>' +
    '<path class="cart-icon-check__mark" d="M11 18.5l4.4 4.4L25 13"/>' +
    '</svg>';

  function playCheck() {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;

    // Le contenu de l'icône est remplacé à chaque mise à jour du panier :
    // on (ré)injecte la coche si elle a disparu.
    var check = icon.querySelector('.cart-icon-check');
    if (!check) {
      check = document.createElement('span');
      check.className = 'cart-icon-check';
      check.innerHTML = CHECK_SVG;
      icon.appendChild(check);
    }

    // Redémarre proprement l'animation même en cas d'ajouts rapprochés.
    check.classList.remove('is-active');
    void check.offsetWidth; // reflow → reset de l'animation
    check.classList.add('is-active');
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    if (event && event.source === 'cart-items') return;
    // Léger délai : laisse le temps au thème de remplacer le contenu de
    // l'icône (renderContents) avant d'injecter la coche par-dessus.
    setTimeout(playCheck, 60);
  });
})();
